export const API_PATH_ApiDeviceMgmtLocationChangeOrder = '/services/devices-mgtm/apiDeviceMgmtLocationChangeOrder';
